<template>
    <v-footer
      dark
      padless
    >
      <v-card
        class="flex"
        flat
        tile
      >
        <v-card-title class="teal">
          <v-row>
            <v-col class="alineacentro">
              <v-btn
                v-for="icon in icons"
                :key="icon.icon"
                class="mx-4"
                dark
                icon
                @click="abrirred(icon.url)"
              >
                <v-icon size="24px">
                  {{ icon.icon }}
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="py-2 white--text text-center">
          {{ new Date().getFullYear() }} — <strong>CAPLP - Colegio de Abogados y Procuradores de La Pampa</strong>
        </v-card-text>
      </v-card>
    </v-footer>
</template>

<script>
export default {
  data: () => ({
    icons: [
        {icon: 'mdi-facebook', url: 'https://www.facebook.com/ColegioAbogadosyProcuradoresLP'},
        {icon: 'mdi-twitter', url: ''},
        {icon: 'mdi-linkedin', url: ''},
        {icon: 'mdi-instagram', url: ''}
      ]
  }),
  methods:{
    abrirred (url) {
      if(url.length>0)
      {
        window.open(url, '_blank')
      }
    }
  }
};
</script>
<style>
.v-list-item__title, .v-list-item__subtitle {
    flex: unset !important; /* 1 1 100%;*/
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color:red !important;
  font-weight:bold !important;
}
.textoNegritaVerde{
  color:rgb(83, 248, 125) !important;
  font-weight:bold !important;
}
.textoNegrita {
  font-weight:bold !important;
}
.textoChicoNegrita {
  font-weight:bold !important;
  font-size: small !important;
}
</style>